module.exports = __webpack_public_path__ + "media/bootstrap-icons/share-fill-969acd87.svg";